import React from 'react';
import './UIKitPage.css';

// REKKIE UIKit is vendored under /uikit (built from uikit/ at compile time).
// We render it inside a same-origin iframe so its DOM-direct CodeMirror +
// canvas layout doesn't have to be ported into React. Same-origin means
// Firebase Auth's IndexedDB persistence is shared, so the iframe picks up
// the parent app's signed-in user automatically.
const UIKitPage = () => (
  <div className="uikit-page">
    <iframe
      title="REKKIE UIKit"
      src="/uikit/"
      className="uikit-frame"
      // allow=clipboard-read/write so format/copy keyboard shortcuts work
      allow="clipboard-read; clipboard-write"
    />
  </div>
);

export default UIKitPage;
